import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/protective_measure/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/protective_measure/insert', data);
  },
  async update(data) {
    return await http.post('/api/protective_measure/update', data);
  },
  async delete(data) {
    return await http.post('/api/protective_measure/delete', data);
  }
};